// Note Edit Page
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import NoteEditor from '../components/NoteEditor';
import { apiClient } from '../services/api';
import type { Note, CreateNoteInput } from '../types/note';

export default function NoteEditPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [note, setNote] = useState<Note | undefined>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (id && id !== 'new') {
      loadNote(id);
    } else {
      setIsLoading(false);
    }
  }, [id]);

  const loadNote = async (noteId: string) => {
    setIsLoading(true);
    const result = await apiClient.getNote(noteId);
    if (result.data) {
      setNote(result.data.note);
    }
    setIsLoading(false);
  };

  const handleSave = async (noteData: CreateNoteInput) => {
    if (note) {
      // Update existing note
      const result = await apiClient.updateNote(note.id, noteData);
      if (result.data) {
        navigate(`/notes/${note.id}`);
      }
    } else {
      // Create new note
      const result = await apiClient.createNote(noteData);
      if (result.data) {
        navigate(`/notes/${result.data.note.id}`);
      }
    }
  };

  const handleCancel = () => {
    if (note) {
      navigate(`/notes/${note.id}`);
    } else {
      navigate('/notes');
    }
  };

  if (isLoading) {
    return (
      <div className="text-center py-12 text-gray-500">
        <div className="animate-pulse">Loading...</div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto">
      {/* Breadcrumb */}
      <nav className="mb-6">
        <button
          onClick={handleCancel}
          className="text-blue-600 hover:text-blue-700 flex items-center gap-2"
        >
          <span>←</span>
          <span>Cancel</span>
        </button>
      </nav>

      <NoteEditor note={note} onSave={handleSave} onCancel={handleCancel} />
    </div>
  );
}
